export enum OperatorOrigin {
    Employee = 'employee',
    Customer = 'customer',
    Cron = 'cron',
    Console = 'console',
    Api = 'api',
    Aesir = 'aesir'
}

export type AuditLogResources = {
    type: string,
    id: string,
    alias: string
}

export type AuditLog = {
    operator: {
        id: string,
        origin: OperatorOrigin,
        name: string
    },
    resources: AuditLogResources[],
    id: string,
    payload: any,
    action: string,
    requestId: string,
    occurrence: number,
    createdAt: string,
    updatedAt: string
}

export type AuditLogsResponse = {
    count: number,
    results: AuditLog[]
}
